import React, { useEffect, useRef, useState } from 'react'
import style from "../asserts/css/overClients.module.css"
import { Link } from 'lucide-react';
export default function OurClients() {
    const clientLogos = [
 {id:1, link:"https://www.bharatbiotech.com/", img:"/images/ourclient/bharat_.svg"},
 { id:2, link:"https://glandpharma.com/", img:"/images/ourclient/gland_.svg"},
 { id:3, link:"https://gufic.com/", img:"/images/ourclient/guficLogo_.svg"},
 { id:4, link:"https://www.hdfclife.com/", img:"/images/ourclient/hdfc_.svg"},
 { id:5, link:"https://higlance.com/", img:"/images/ourclient/higlance_.svg"},
 { id:6, link:"https://www.goindigo.in/", img:"/images/ourclient/indiGO_.svg"},
 { id:7, link:"https://www.axismaxlife.com/", img:"/images/ourclient/max-life_.svg"},
 { id:8, link:"https://www.motorola.in/", img:"/images/ourclient/motorola_.svg"},
//  { id:9, link:"https://www.ranbaxylabs.com/", img:"/images/ourclient/ranbaxy_.svg"},
 { id:10, link:"https://www.sbilife.co.in/", img:"/images/ourclient/sbiLife_.svg"},
 { id:11, link:"https://www.samsung.com/", img:"/images/ourclient/sumsung_.svg"},
 { id:12, link:"https://sunpharma.com/", img:"/images/ourclient/sun_.svg"},
 { id:13, link:"https://www.tataaig.com/", img:"/images/ourclient/tataAIG_.svg"},
 { id:14, link:"https://www.wockhardt.com/", img:"/images/ourclient/wockhardt_.svg"},
 { id:15, link:"https://www.zyduslife.com/", img:"/images/ourclient/zydus_.svg"},
 
];



  return (
    <>
  
<div className={style.clientsslidercontainer} style={{paddingTop:"65px"}}>
   <h1 className='text-center mb-5' >OUR CLIENTS</h1>
      <div className={style.clientsslidertrack}>
        {[...clientLogos, ...clientLogos].map((logo, index) => (
          // <a href={logo.link} target='_blank'>
          <div className={style.clientlogobox} key={index}>
            <img
              src={`${logo.img}`}
              alt={`client-${index}`}
              className={style.clientlogoimg}
            />
          </div>
          // </a>
        ))}
      </div>
    </div>
    
    </>
  )
}
